import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import Sidebar from "./Sidebar";
import SidebarAdvertiser from "./SidebarAdvertiser";
import SidebarPhotographer from "./SidebarPhotographer";
import SidebarVehicle from "./SidebarVehicle";
import SidebarDesigner from "./SidebarDesigner";
import { useState } from "react";

const Layout = ({ user, vehicle }) => {
  const [profile_url, setProfile_url] = useState(
    require("../assets/img/account-icon.png")
  );
  return (
    <div
      className="main "
      style={{ height: "100vh", paddingTop: "1.5rem", paddingBottom: "1.5rem" }}
    >
      <div className="row align-item-center justify-content-center w-100">
        <div className="col-lg-2   ">
          {user == 1 && <Sidebar values={{ profile_url, setProfile_url }} />}
          {user == 3 && (
            <SidebarAdvertiser values={{ profile_url, setProfile_url }} />
          )}
          {user == 2 && (
            <SidebarPhotographer values={{ profile_url, setProfile_url }} />
          )}
          {user == 4 && (
            <SidebarVehicle values={{ profile_url, setProfile_url }} />
          )}
          {user == 5 && (
            <SidebarDesigner values={{ profile_url, setProfile_url }} />
          )}
        </div>
        <div className="pe-0 pe-md-2 col-lg-8 col-12  main-content ">
          <div className="mt-3">
            <div
              className="site-content"
              style={{
                minHeight: "95vh",
                borderRadius: "0px 20px 20px 0px",
                overflow: "scroll",
              }}
            >
              <div className="p-sm-2 p-1">
                <Navbar />
                <div style={{ height: "80vh" }}>
                  <Outlet context={{ profile_url, setProfile_url }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
